
export default {
  meta: {
    seo: {
      title: 'home.metaTitle',
      description: 'home.metaDescription',
      searchbox: true
    }
  }
}
